export default {
  "ORDER_WAIT_SHIP": "배송대기",
  "Men fashion": "남성 패션",
  "MyAccount_MyProfile_label_First": "이름",
  "MyAccount_MyShippingDetails_Phone": "전화번호",
  "Page_not_found_message1": "죄송합니다. 해당 페이지를 찾을 수 없습니다.",
  "Help": "도움말",
  "Sign in": "로그인",
  "Register": "회원가입",
  "Category_sorting_Item": "정렬 방법 선택",
  "cart_clear": "장바구니 비우기",
  "Payment & Delivery": "결제 및 배송",
  "Send my feedback": "피드백 보내기",
  "MyAccount_MyProfile_Save": "변경 사항 저장",
  "Continue_billing": "계속해서 결제",
  "Categories": "카테고리",
  "Read and understand": "내용을 읽고 이해했습니다",
  "Feel free to edit": "계정 정보를 언제든지 수정할 수 있습니다. 계정 정보가 항상 최신 상태를 유지하도록 합니다",
  "Select payment method": "결제 방법 선택",
  "Login_input_email": "이메일 주소",
  "Login_input_first": "이름",
  "Account": "계정",
  "Create_Time_Asc": "생성날짜 오름차순",
  "concactus_label": "의견 또는 질문",
  "Order_Grade": "주문 평가",
  "wishlist_empty_desc": "아직 장바구니에 상품을 추가하지 않으셨습니다. 쇼핑을 시작해보세요!",
  "cartpreviewShipping_messageinfo": "배송 확인 및 도착 예정일을 알려드립니다.",
  "unsubscribe": "언제든지 구독 취소할 수 있습니다.",
  "prompt": "알림",
  "MyAccount_MyProfile_yinsi_message": "Brand name에서는 개인 정보 보호를 매우 중요시하며 사용자의 개인 데이터를 보호하는 데 신중하게 대응합니다. 귀하의 개인 데이터에 대한 우리의 관심과 사용 방법에 대한 자세한 정보를 참조하십시오.",
  "About us": "회사 소개",
  "or": "또는",
  "MyAccount_Order_History_All": "전체 주문",
  "What_We_Improve": "우리는 어떻게 개선할까요?",
  "MyAccount_ShippingDetails_title": "배송 상세정보",
  "MyAccount_Order_History_Tabs2": "미지급",
  "Go_back_shopping": "쇼핑 계속하기",
  "Product": "상품",
  "Order summary": "주문 요약",
  "payment_order_total": "주문 총액",
  "Departments": "법적 성명",
  "Download": "다운로드",
  "Your_Purchase_Order": "구매 주문 내역",
  "Your_Account": "내 계정",
  "order_after_sales_list_null": "현재 후원 주문이 없습니다.",
  "All_After_sales_orders": "전체 후원 주문",
  "Filters": "필터",
  "search_results_not": "입력한 어구와 일치하는 결과를 찾지 못했습니다.",
  "ORDER_WAIT_RECEIPT": "수령대기",
  "ORDER_CLOSED": "주문 마감",
  "Order_View_details": "자세히 보기",
  "Subscribe_to_message": "판매 및 이벤트 정보를 알아보세요. 선물과 특별 혜택을 받으세요!",
  "TaxFee": "세금 및 요금",
  "Apply": "적용",
  "Total_price": "총 가격",
  "Description": "제품 설명",
  "Payment method": "결제 방법",
  "Back": "뒤로가기",
  "Empty": "아직 장바구니에 상품을 추가하지 않으셨습니다. 쇼핑을 시작해보세요!",
  "After_sales": "후원 주문",
  "Instruction3": "예, 알겠습니다.",
  "MyAccount_MyShippingDetails_Last": "성",
  "MyAccount_MyShippingDetails_City": "도시",
  "payment_order_discount": "주문 할인",
  "MyAccount_Order": "주문 상세정보",
  "ID_Name_Error": "신분증 이름을 입력하세요.",
  "Kidswear": "아동복",
  "Share your look": "나의 룩 공유하기",
  "Pay_Order": "주문 결제",
  "Reset_Password": "비밀번호 재설정",
  "MyAccount_MyProfile_label2_pass1": "현재 비밀번호",
  "Create_Time_Desc": "생성날짜 내림차순",
  "Items": "상품 목록",
  "Login_Register": "회원가입하기",
  "Back to homepage": "홈으로 돌아가기",
  "switch_CNY": "인민폐로 전환",
  "Successful placed order": "주문이 완료되었습니다. 주문 상태를 확인하려면 전달 상태 기능을 사용할 수 있습니다. 주문 확인 이메일을 받게 됩니다. 주문 세부 정보와 추적 링크가 포함되어 있습니다.",
  "MyAccount_MyProfile_yinsi_link": "개인정보취급방침",
  "Order_Date": "주문 날짜",
  "Allow order notifications": "주문 알림을 허용합니다",
  "MyAccount_MyProfile_Tab1": "개인 정보",
  "MyAccount_ShippingDetails_changeTitle": "배송지 변경",
  "ID_Number": "신분증 번호",
  "Order_after_sales_message": "주문 상세정보와 후원 주문",
  "MyAccount_MyProfile_title2": "계정에 액세스하는 비밀번호를 변경하려면 다음 정보를 입력하세요.",
  "Customer service": "고객 서비스",
  "MyAccount_MyProfile_Update": "비밀번호 업데이트",
  "choose_language": "언어 선택",
  "ORDER_REFUNDING": "환불 진행중",
  "MyAccount_MyProfile_title1": "이하 세부 정보는 언제든지 수정하실 수 있습니다. 계정 정보를 최신 상태로 유지해주세요.",
  "ORDER_WAIT_RATE": "평가 대기",
  "after_sales_refund_order": "주문 환불",
  "Who we are": "우리는 누구인가",
  "Women fashion": "여성 패션",
  "Personal details": "개인정보",
  "Password": "비밀번호",
  "wishlist_empty_title": "장바구니가 비었습니다",
  "Repeat_Password": "비밀번호 확인",
  "cart_price": "소계",
  "Sort_by": "정렬 방법",
  "Customer Reviews": "고객 리뷰",
  "Continue to shipping": "운송 계속하기",
  "payment_make_order": "주문하기",
  "save_order_review": "평가 제출",
  "Save_Password": "비밀번호 저장",
  "cart_empty_title": "장바구니가 비었습니다",
  "TopBar_help": "도움말 및 자주 묻는 질문",
  "colseCookie": "알겠습니다",
  "Password_Changed": "비밀번호가 성공적으로 변경되었습니다. 이제 홈페이지로 돌아가서 로그인하세요.",
  "Forgot Password Modal Email": "이메일 주소",
  "MyAccount_Personal": "개인정보",
  "cartPreviewShipping": "간편한 운송",
  "ORDER_AFTER_SALE": "서비스 완료",
  "Page_not_found": "페이지를 찾을 수 없습니다.",
  "Find out more": "자세히 알아보기",
  "Log into your account": "내 계정으로 로그인",
  "Details_and_status_orders": "온라인 스토어에서 주문의 세부 정보와 상태를 확인합니다. 주문 취소 또는 반품을 요청할 수도 있습니다.",
  "Order_to_be_paid_message": "지급 대기 중",
  "Guarantee": "보증",
  "Sections that interest you": "관심 있는 섹션",
  "payment_post_tax": "우편 비용 세금",
  "ORDER_PAID": "지불 완료",
  "concactus_label5": "이름",
  "Item": "상품",
  "Go_back": "돌아가기",
  "more": "더 보기",
  "MyAccount": "내 계정",
  "payment_agree_1": "동의합니다",
  "total_items": "총 수량",
  "shopping_go": "배송지 관리",
  "ID_Type": "신분증 유형",
  "after_sales_status": "서비스 상태",
  "After_sales_apply": "서비스 신청",
  "Login": "로그인",
  "Quantity": "수량",
  "payment_post_fee": "우편비",
  "MyAccount_Log_out": "로그아웃",
  "Subtotal": "소계",
  "forgotPasswordConfirmation": "감사합니다! 계정에 등록된 {0} 이메일을 사용하여 비밀번호 재설정 링크가 포함된 메시지가 받은 편지함에 있을 것입니다.",
  "MyAccount_Order_History_Tabs1": "내 주문",
  "concactus_img": "사진 업로드",
  "Done": "완료",
  "Info after order": "이전에 정의한 이메일과 비밀번호를 사용하여 계정에 로그인할 수 있습니다. 계정에서 개인 정보를 편집하고 거래 내역을 확인하고 구독 정보를 편집할 수 있습니다.",
  "MyAccoubnt_Set_newsletter": "뉴스 레터를 설정하면 매주 새로 추가 된 제품과 트렌드 정보의 선택된 섹션을 받게됩니다.",
  "Shipping_method": "배송 방법",
  "after_sales_refund": "환불 금액",
  "After_sales_save": "서비스 정보 저장",
  "go_order_history": "주문 기록 보기",
  "contactus_message_placeholder": "의견 또는 질문을 입력하세요.",
  "Login_Forgot_Password": "비밀번호를 기억할 수 없으면 재설정할 수 있습니다.",
  "show_more": "더보기",
  "MyAccount_MyProfile_label_email": "이메일",
  "MyAccount_MyProfile_label2_pass3": "비밀번호 확인",
  "Products": "제품",
  "Review": "리뷰",
  "MyAccount_MyProfile_title3": "현재의 이메일 주소는 다음과 같습니다",
  "Category_found_Products": "찾은 제품",
  "Match": "매치",
  "Read_all_reviews": "모든 리뷰 읽기",
  "Commercial information": "Brand name의 맞춤형 상업 정보를 이메일로 수신하는 것에 동의합니다.",
  "Change password your account": "계정 액세스 암호를 변경하려면 다음 정보를 입력하십시오.",
  "ID_Name": "신분증 이름",
  "All": "전체",
  "Instruction2": "관리 설명서만 필요한 경우?",
  "MyAccount_ShippingDetails_Add": "새 주소 추가",
  "MyAccount_MyShippingDetails_Zip": "우편 번호",
  "go_pay_order": "결제하러 가기",
  "Thank_You_Inbox": "메시지가 받은 편지함에 도착하지 않으면 등록에 사용한 다른 이메일 주소를 시도해보십시오.",
  "Subscribe": "구독하기",
  "confirm_subscription": "구독을 확인합니다",
  "Login_input_Remember": "로그인 상태 유지",
  "Add to compare": "비교 추가",
  "Brand": "브랜드",
  "Start_shopping": "쇼핑 시작",
  "Select shipping method": "배송 방법 선택",
  "address CN": "주소가 중국인 경우 현재 통화는 CNY여야합니다.",
  "MyAccount_MyShippingDetails_State": "지역",
  "Page_not_found_message2": "돌아가거나 다시 시도하십시오.",
  "Go_to_checkout": "체크 아웃하러 가기",
  "See all results": "모든 결과 보기",
  "search_results_inputnull": "아직 검색한 상품이 없습니다",
  "subscribeToNewsletterModalContent": "뉴스 레터를 구독하면 VSF의 특별 제안 및 정보를 이메일로 받게됩니다. 우리는 언제든지 귀하의 이메일을 제3자에게 판매 또는 배포하지 않습니다. {0}을 참조하십시오.",
  "Download all": "전체 다운로드",
  "Login_input_last": "성",
  "Amount": "금액",
  "ORDER_WAIT_PAYMENT": "지불 대기 중",
  "Order_After_sales": "주문 후 판매",
  "concattus_button": "제출",
  "Shipping_valid_required": "이 항목은 필수입니다",
  "Price": "가격",
  "ID_Type_Error": "신분증 유형을 선택해주세요",
  "Order_Status": "주문 상태",
  "Payment methods": "지불 방법",
  "MyAccount_MyProfile_Tab2": "비밀번호 변경",
  "Show on page": "페이지에 표시",
  "Edit": "편집",
  "Change": "변경",
  "MyAccount_ShippingDetails_Update": "주소 업데이트",
  "View": "보기",
  "Privacy": "개인 정보 보호",
  "Enter_promo_code": "프로모션 코드 입력",
  "Discount": "할인",
  "Delete": "삭제",
  "Wishlist": "찜 목록",
  "MyAccount_Order_History_Tabs3": "반품",
  "Go_To_Order_review": "평가로 이동",
  "Update personal data": "개인 정보 업데이트",
  "payment_agree_2": "약관 및 조건",
  "or fill the details below": "또는 아래 상세 정보를 입력하세요",
  "Contact details updated": "주소와 연락처 정보를 최신 상태로 유지하세요.",
  "Login_Create": "계정 생성",
  "Payment": "지불",
  "Billing": "청구서",
  "payment_insurance_tax": "보험 세금",
  "Size guide": "사이즈 가이드",
  "Login_forgotten_password": "비밀번호를 잊으셨나요?",
  "Login_no_account": "아직 계정이 없으신가요?",
  "Privacy_Policy": "개인 정보 보호 정책",
  "BootomCookieTitle": "쿠키 동의",
  "Use your personal data": "Brand name에서는 고객님들의 개인 정보 보호를 매우 중요하게 생각하며, 고객님의 개인 정보를 보호하기 위해 최선을 다하고 있습니다. 고객님의 개인 정보를 다루는 Brand name의 정책에 대해 자세히 알아보시려면 다음을 참조하세요.",
  "Review my order": "내 주문 확인",
  "BootomCookieLink": "자세히 알아보기",
  "hide": "숨기기",
  "MyAccount_ShippingDetails_message_title": "배송 주소를 관리하세요(직장, 자택 등) 이를 통해 매 주문마다 배송 주소를 수동으로 입력할 필요 없습니다.",
  "Purchase terms": "구매 조건",
  "Billing_address": "청구서 주소",
  "Manage shipping addresses": "배송 주소를 관리하세요(직장, 자택 등) 이를 통해 매 주문마다 배송 주소를 수동으로 입력할 필요 없습니다.",
  "login_logbtn": "로그인",
  "choose_currency": "통화 선택",
  "ORDER_REFUNDED": "환불 완료",
  "After_sales_form": "판매 후 양식 작성",
  "add_To_Wishlist": "찜 목록에 추가",
  "search_results_inputnull2": "시작해 보세요. 저희가 도와드릴게요.",
  "Total": "총액",
  "Subscribe_to_newsletter": "뉴스레터 구독",
  "Shipping_valid_Phone": "올바른 전화번호를 입력하세요",
  "concactus_label3": "제목",
  "Manage billing addresses": "청구서 주소를 관리하세요(직장, 자택 등) 이를 통해 매 주문마다 청구서 주소를 수동으로 입력할 필요 없습니다.",
  "Search_results_title": "검색 결과",
  "payment_order_payment": "주문 결제",
  "after_sales_Id": "판매 후 ID",
  "cart_title": "내 장바구니",
  "Order_Detail": "주문 세부 정보",
  "concactus_label2": "상점 링크",
  "Shipping_valid_length_min": "이 필드는 최소 {min} 자 이상이어야합니다.",
  "Product suggestions": "제품 제안",
  "Return_home": "홈으로 돌아가기",
  "Quality in the details": "세부 사항에서의 품질",
  "Continue_to_payment": "지불 계속",
  "Feedback": "고객님의 피드백은 매우 중요합니다. 어떻게 개선할 수 있는지 알려주세요.",
  "Go back to shop": "쇼핑몰로 이동",
  "Back_to_home": "홈으로 돌아가기",
  "Review_Content": "평가 내용",
  "add_To_Cart": "장바구니에 추가",
  "Read_reviews": "리뷰 읽기",
  "Instruction1": "유지 관리 방법",
  "Email_address": "이메일 주소",
  "Category_Item_List": "목록 보기로 전환",
  "Same as shipping address": "배송 주소와 동일",
  "Category_Item_Grid": "그리드 보기로 전환",
  "ID_Number_Error": "신분증 번호를 입력하세요",
  "concactus_label4": "연락 이메일",
  "Additional_info": "추가 정보",
  "add_shipping": "새 배송 주소 추가",
  "Product_description": "Karissa V-Neck Tee는 밀착형 디자인으로 어떤 체형에도 잘 어울립니다. 곡선을 따라 구부리는 문제 특정 영역을 가리므로 체육관에서 자신감 있게 착용할 수 있습니다. 멋진 여성 칵테일 드레스와 파티 드레스도 구비하고 있습니다.",
  "Login_create_account": "계정 만들기",
  "after_sales_Reason": "판매 후 이유",
  "MyAccount_MyProfile_label_Last": "성",
  "MyAccount_MyProfile_label2_pass2": "새 비밀번호",
  "Save": "저장",
  "CartSliderTextBtn": "나중에 구매할 항목 저장",
  "Color": "색상",
  "Shipping_Tax": "배송 세금",
  "Subscribe_to_success": "구독 신청이 완료되었습니다",
  "Enjoy your free account": "무료 계정 혜택을 즐기세요!",
  "cart_empty_desc": "장바구니에 상품을 추가하지 않았습니다. 쇼핑을 시작하여 채워보세요.",
  "MyAccount_ShippingDetails_message_title2": "주소와 연락처 정보를 최신 상태로 유지하세요.",
  "An_error_occured": "오류가 발생하였습니다",
  "Country": "국가",
  "MyAccount_MyShippingDetails_First": "이름",
  "payment_insurance_fee": "보험료",
  "Home": "홈",
  "Contact_us": "문의하기",
  "Cookies Policy": "쿠키 정책",
  "Clear all": "모두 지우기",
  "Basket": "장바구니",
  "MyAccount_MyProfile_reqeatPassErrMsg": "새 비밀번호가 일치하지 않습니다",
  "Your current email address is": "현재 이메일 주소는",
  "You currently have no orders": "주문이 없습니다",
  "Login_input_password": "비밀번호",
  "Promo_code": "프로모션 코드",
  "order_count": "주문 수",
  "email_geshi_error": "유효한 이메일 주소를 입력하세요",
  "your_email": "당신의 이메일",
  "email": "이메일",
  "you_have_subscribed": "구독 중입니다",
  "cancel_Subscribe": "구독 취소",
  "save_and_pay": "저장 및 결제",
  "hasInsurance": "보험을 구입하시겠습니까?",
  "pleasePayType": "결제 방법을 선택해주세요",
  "zhuanfa_toBePay": "친구가 대신 결제할 수 있도록 공유하기",
  "linkCopied": "링크가 복사되었습니다. 친구에게 공유해보세요!",
  "Links": "링크",
  "article_category": "글 카테고리",
  "wechat_code_login_message": "위챗으로 이용해 로그인해주세요",
  "wechat_code_login": "위챗으로 로그인",
  "Api_Update_success": "업데이트 성공",
  "Please_Use_WeChat_login": "위챗으로 로그인해주세요",
  "mobile_geshi_error": "유효한 휴대폰 번호를 입력해주세요",
  "Login_input_email_required": "이메일을 입력해주세요",
  "article_null": "게시글이 없습니다",
  "Login_with_microsoft": "마이크로소프트로 로그인",
  "article_null_des": "다른 분류의 게시글을 볼 수 있습니다",
  "register_email": "이메일로 가입하기",
  "Login_tab_email": "이메일 로그인",
  "code.time": "{time}초 후 다시 시도해주세요",
  "Login_with_wechat": "위챗으로 로그인",
  "cat_items_null_des": "다른 분류의 상품을 볼 수 있습니다",
  "Login_with_facebook": "페이스북으로 로그인",
  "Login_input_code": "인증번호를 입력해주세요",
  "Login_input_mobile_required": "휴대폰 번호를 입력해주세요",
  "Login_input_mobile": "휴대폰 번호",
  "cat_items_null": "해당 분류에 상품이 없습니다",
  "Login_with_twitter": "트위터로 로그인",
  "mobile_code": "인증번호",
  "register_mobile": "휴대폰으로 가입하기",
  "Login_tab_mobile": "휴대폰 로그인",
  "Login_with_google": "구글로 로그인",
  "OrderSku": "제품 규격",
  "Order_logisticsNo": "운송장 번호",
  "order_shopping_firstname": "이름",
  "Order_logisticsName": "택배 회사",
  "ItemPrice": "상품 금액",
  "inPayOrderAll": "결제 대기 목록",
  "payPrice": "결제 금액",
  "shipping_add_success": "배송지 생성 완료",
  "match_goods": "인기 상품",
  "pay_code_refresh": "결제 코드 새로 고침",
  "pay_code_shixiao": "결제 QR코드가 만료되었습니다.",
  "concactus_title": "연락처",
  "Search_items": "검색",
  "WebAutoLang": "현재 브라우저의 추천 언어는 {lang}입니다. 해당 언어로 변경하시겠습니까?",
  "Services_Name": "서비스 이름",
  "Services_Price": "서비스 요금",
  "SwichLang": "언어 변경",
  "Services_Description": "서비스 설명",
  "goodinfo_null": "상품 없음",
  "goodinfo_null_des": "다른 분류의 상품을 볼 수 있습니다",
  "notYetUseCode": "미사용 쿠폰",
  "guest_Login": "게스트 로그인",
  "billing_and_shipping": "청구서 및 배송 주소 일치",
  "select_coupon": "쿠폰 선택",
  "select_gift": "선물 선택",
  "currentUseCode": "이미 사용한 쿠폰",
  "shipping_refresh": "리스트 새로고침",
  "Shipping_details": "배송지 정보",
  "MyAccount_Newsletter": "구독",
  "MyAccount_Profile": "정보",
  "MyAccount_Wishlist": "찜목록",
  "See_all": "모두 보기",
  "MyAccount_History": "주문 기록",
  "bind_microsoft": "바인드 마이크로소프트",
  "bind_twitter": "트위터 바인드",
  "bind_facebook": "Facebook 바인드",
  "bind_wechat_code": "위챗 QR 코드",
  "bind_wechat": "위챗바인드",
  "bind_google": "Google 바인드",
  "Wishlist_Empty": "위시리스트가 비어 있습니다.",
  "discount_post_fee": "우편비할인",
  "ORDER_PART_PAID": "부분지불",
  "claimCouponeSuccess": "{name} 쿠폰 수령 성공",
  "discount_kou": "{할인율} 할인",
  "claimCoupone": "수령",
  "cartPreviewSafety_messageinfo": "안전하고 빠른 배송이 당신의 주소로 제공됩니다",
  "Order_No": "주문 번호",
  "cartPreviewSafety": "안전배송",
  "Shipping": "배송",
  "MyAccount_MyShippingDetails_Street": "거리",
  "MyAccount_MyShippingDetails_HouseNumber": "집 번호",
  "Shipping_title": "수취인 주소",
  "Offline_payment": "오프라인 결제",
  "shopName": "상점 이름",
  "Social": "소셜",
  "SERVICE": "서비스",
  "onlineContact": "온라인으로 연락하기",
  "confirm": "확인",
  "closeOrder": "주문 취소",
  "closeOrderContext": "주문을 취소하시겠습니까?",
  "Message_Read": "읽음",
  "close.order.success": "주문 취소 성공",
  "shippingAddress": "상세 주소",
  "Message": "메시지",
  "Message_Empty_Title": "귀하의 메시지가 비어 있습니다",
  "MyAccount_Message": "메시지",
  "Message_Empty": "메시지가 없습니다",
  "payment_order_note": "주문 비고",
  "go_to_see_prepid": "미결제 주문 보기를 보려면 여기를 클릭하세요",
  "operate": "조작",
  "removeCartItemContext": "{title}을(를) 제거 하시겠습니까?",
  "shippingItemQty": "배송 수량",
  "removeCartItem": "상품 제거",
  "shippingInfo": "배송 정보",
  "Distributor_success": "이미 성공적으로 유통 업체로 등록되었습니다.",
  "Distributor_apply": "유통 업체로 신청하기",
  "Distributor_Details": "유통 업체",
  "DistributorSataus": "상태",
  "Distributor_Details_Empty": "유통 업체가 없습니다.",
  "distributor.status.4": "폐기됨",
  "distributor.status.1": "미승인",
  "Distributor_copy_url": "유통 링크 복사하기",
  "Order_Time": "주문 시간",
  "Order_User": "주문자",
  "Distributor_copy_success": "복사 성공",
  "distributor.status.3": "결산 완료",
  "MyAccount_Distributor": "유통 업체",
  "MyAccoubnt_Set_Distributor": "유통 업체로 신청하기",
  "distributor.status.2": "결산 대기 중",
  "DistributorAmount": "커미션",
  "Distributor_shenheshibai": "판매자 검토 미통과",
  "Distributor_shenhezhong": "판매자 검토 중",
  "Distributor_Order_Empty": "분배 주문 없음",
  "NE": "니제르",
  "DJ": "지부티",
  "KP": "북한",
  "US": "미국",
  "LC": "세인트루시아",
  "NL": "네덜란드",
  "CD": "콩고민주공화국",
  "IS": "아이슬란드",
  "MA": "모로코",
  "GH": "가나",
  "KR": "한국",
  "MK": "마케도니아 공화국",
  "HT": "아이티",
  "PF": "프랑스령 폴리네시아",
  "GA": "가봉",
  "TD": "차드",
  "LB": "레바논",
  "CG": "콩고",
  "KG": "키르기스스탄",
  "TA": "트리스탄다쿠나 섬",
  "KW": "쿠웨이트",
  "TL": "동티모르",
  "IN": "인도",
  "NO": "노르웨이",
  "NG": "나이지리아",
  "AQ": "남극",
  "LY": "리비아",
  "NI": "니카라과",
  "TT": "트리니다드 토바고",
  "HM": "허드 맥도널드 제도",
  "PY": "파라과이",
  "BA": "보스니아 헤르체고비나",
  "JP": "일본",
  "MD": "몰도바",
  "MT": "몰타",
  "RE": "레위니옹 섬",
  "UG": "우간다",
  "SB": "솔로몬 제도",
  "SL": "시에라리온",
  "CV": "카보베르데",
  "SD": "수단",
  "FO": "페로 제도",
  "ZA": "남아프리카",
  "TR": "터키",
  "FK": "포클랜드 제도",
  "PA": "파나마",
  "GF": "프랑스령 기아나",
  "TJ": "타지키스탄",
  "NC": "누벨칼레도니",
  "PM": "생피에르 미클롱 군도",
  "NU": "누이",
  "AO": "앙골라",
  "VN": "베트남",
  "GN": "기니",
  "MW": "말라위",
  "BY": "벨라루스",
  "IM": "맨 섬",
  "BI": "부룬디",
  "BS": "바하마",
  "CK": "쿡 제도",
  "MH": "마셜 제도",
  "CR": "코스타리카",
  "HK": "홍콩 특별행정구",
  "AD": "안도라",
  "BN": "브루나이",
  "SN": "세네갈",
  "AE": "아랍에미리트",
  "GI": "지브롤터",
  "CA": "캐나다",
  "AX": "올란드 제도",
  "UY": "우루과이",
  "WF": "왈리스-푸투나",
  "GM": "감비아",
  "SO": "소말리아",
  "RU": "러시아",
  "PL": "폴란드",
  "FM": "미크로네시아",
  "ET": "에티오피아",
  "EE": "에스토니아",
  "SK": "슬로바키아",
  "AS": "미국령 사모아",
  "ZM": "잠비아",
  "AL": "알바니아",
  "AT": "오스트리아",
  "VA": "바티칸시국",
  "TW": "대만",
  "BD": "방글라데시",
  "AR": "아르헨티나",
  "EH": "서사하라",
  "MO": "마카오(중국 특별행정구)",
  "MV": "몰디브",
  "GU": "괌",
  "AW": "아루바",
  "AI": "앵귈라",
  "CL": "칠레",
  "IL": "이스라엘",
  "GD": "그레나다",
  "WS": "사모아",
  "SE": "스웨덴",
  "GP": "과들루프",
  "YE": "예멘",
  "GT": "과테말라",
  "BG": "불가리아",
  "SJ": "스발바르 얀마옌",
  "CO": "콜롬비아",
  "LS": "레소토",
  "LV": "라트비아",
  "UM": "미국령 해외 제도",
  "MX": "멕시코",
  "DO": "도미니카 공화국",
  "PE": "페루",
  "HN": "온두라스",
  "TC": "터크스 케이커스 제도",
  "VI": "미국령 버진아일랜드",
  "FJ": "피지",
  "MP": "북마리아나 제도",
  "AC": "어센션 섬",
  "NA": "나미비아",
  "SZ": "스와질란드",
  "RW": "르완다",
  "BH": "바레인",
  "KN": "세인트키츠 네비스",
  "TN": "튀니지",
  "AF": "아프가니스탄",
  "VG": "영국령 버진아일랜드",
  "KE": "케냐",
  "PK": "파키스탄",
  "GL": "그린란드",
  "SY": "시리아",
  "CU": "쿠바",
  "RS": "세르비아",
  "BF": "부르키나파소",
  "BM": "버뮤다",
  "BZ": "벨리즈",
  "SV": "엘살바도르",
  "CN": "중국",
  "MF": "생마르탱",
  "NF": "노퍽섬",
  "MZ": "모잠비크",
  "LU": "룩셈부르크",
  "TO": "통가",
  "GR": "그리스",
  "SI": "슬로베니아",
  "PW": "팔라우",
  "TZ": "탄자니아",
  "IR": "이란",
  "GG": "건지섬",
  "SM": "산마리노",
  "TF": "프랑스령 남부와 남극",
  "PS": "팔레스타인",
  "SC": "세이셸",
  "BT": "부탄",
  "JM": "자메이카",
  "BR": "브라질",
  "CH": "스위스",
  "SH": "세인트헬레나",
  "HU": "헝가리",
  "TM": "투르크메니스탄",
  "LT": "리투아니아",
  "MC": "모나코",
  "LI": "리히텐슈타인",
  "LR": "라이베리아",
  "GE": "조지아",
  "SA": "사우디아라비아",
  "GB": "영국",
  "VE": "베네수엘라",
  "MU": "모리셔스",
  "HR": "크로아티아",
  "SR": "수리남",
  "CM": "카메룬",
  "IQ": "이라크",
  "BO": "볼리비아",
  "MN": "몽골",
  "DZ": "알제리",
  "TK": "토켈라우",
  "MG": "마다가스카르",
  "YT": "마요트",
  "CC": "코코스(킬링) 제도",
  "LA": "라오스",
  "PT": "포르투갈",
  "QA": "카타르",
  "AN": "네덜란드령 안틸리스",
  "PN": "핏케언(얌궁) 섬",
  "ES": "스페인",
  "VC": "세인트빈센트 그레나딘",
  "AU": "호주",
  "CX": "크리스마스섬",
  "KM": "코모로",
  "MR": "모리타니",
  "FR": "프랑스",
  "SG": "싱가폴",
  "BV": "부베(북극) 섬",
  "PH": "필리핀",
  "CY": "키프로스",
  "TV": "투발루",
  "CF": "중앙아프리카 공화국",
  "EC": "에콰도르",
  "GW": "기니비사우",
  "IE": "아일랜드",
  "LK": "스리랑카",
  "ER": "에리트리아",
  "GQ": "적도기니",
  "NP": "네팔",
  "BE": "벨기에",
  "GY": "가이아나",
  "DK": "덴마크",
  "MQ": "마르티니크",
  "UZ": "우즈베키스탄",
  "CI": "코트디부아르",
  "ID": "인도네시아",
  "BJ": "베냉",
  "ST": "상투메 프린시페",
  "KH": "캄보디아",
  "KZ": "카자흐스탄",
  "MS": "몬트세랫",
  "TH": "태국",
  "FI": "핀란드",
  "ML": "말리",
  "AM": "아르메니아",
  "IT": "이탈리아",
  "NR": "나우루",
  "PG": "파푸아뉴기니",
  "ZW": "짐바브웨",
  "JO": "요르단",
  "OM": "오만",
  "ME": "몬테네그로",
  "JE": "저지섬",
  "NZ": "뉴질랜드",
  "VU": "바누아투",
  "DE": "독일",
  "CZ": "체코공화국",
  "DM": "도미니카",
  "KY": "케이맨 제도",
  "BW": "보츠와나",
  "RO": "루마니아",
  "PR": "푸에르토리코",
  "AZ": "아제르바이잔",
  "IO": "영국령 인도양 지역",
  "UA": "우크라이나",
  "TG": "토고",
  "MY": "말레이시아",
  "AG": "앤티가 바부다",
  "EG": "이집트",
  "GS": "사우스조지아 사우스샌드위치 제도",
  "MM": "미얀마",
  "BB": "바베이도스",
  "KI": "키리바시",
  "All_Country": "전체",
  "post_state_country": "배송비: {country} {state} {postFee}",
  "zhichiDeliveryCountry": "배송지",
  "ShippingFee": "배송비",
  "reviewOutOf": "{rating} 별, 총 5 별",
  "product.pifa.label": "{startnum} - {endnum}개 구매",
  "product.pifa.type.1": "할인",
  "Write_a_review": "리뷰 작성",
  "BasedOnTotalReviews": "{total}개 리뷰 기반",
  "product.wholesale": "도매 가격",
  "reviewMostRecent": "최신 리뷰",
  "product.pifa.type.2": "단가",
  "product.num.danwei": "개",
  "good.shoppingDateLabel": "배송 시간",
  "good.shippingPeriod": "일 이내 배송",
  "emailError": "이메일 형식 오류",
  "addressNote": "참고",
  "Concactus": "연락",
  "addressMessage": "주소를 정확하게 입력해주세요. 체크아웃 후 주소를 변경할 수 없습니다.",
  "showOrderSummary": "주문 요약",
  "payment_method": "결제 방법",
  "emailNotNullError": "이메일을 입력해주세요.",
  "orderCreateLoading": "주문 생성 중...",
  "emailNote": "연락",
  "emailMessage": "이메일 주소가 정확한지 확인해주세요. 주문 확인 이메일이 발송됩니다.",
  "payment_method_message": "모든 거래는 안전하고 암호화됩니다.",
  "go_buy_goods": "쇼핑 계속하기",
  "tap_cancel_order": "여기를 클릭하여 주문 취소",
  "order_review": "주문 평가",
  "Add_new_address": "새 주소 추가",
  "promo_code_type_3": "마케팅 쿠폰",
  "IdCardNotNull": "실명 정보를 입력하세요",
  "UploadVideo": "비디오 업로드",
  "video": "비디오",
  "UploadImage": "이미지 업로드",
  "uploadImageing": "업로드 중...",
  "BillingInfoNotNull": "빌링 정보가 불완전합니다",
  "promo_code_type_2": "할인 쿠폰",
  "UploadError": "업로드 실패",
  "promo_code_type_4": "배송비 할인 쿠폰",
  "image": "이미지",
  "paymentMethodNotNull": "지불 방법을 선택하세요",
  "promo_code_type_1": "할인 쿠폰",
  "shippingInfoNotNull": "배송 정보가 불완전합니다",
  "reviewDetail": "평가 세부 정보",
  "DeliveryCountry": "배송 지역",
  "prompt_error": "알림 오류",
  "save_review_success": "평가가 성공적으로 완료되었습니다",
  "ORDER_COMPLETED": "완료됨",
  "crate_after_sales": "반품 만들기",
  "Thank_You_Order": "주문 감사합니다!",
  "Thank_You_Order_sub": "조금 있으면 주문이 처리될 예정입니다. 주문 처리에 관한 이메일을 받게 될 것입니다.",
  "BootomCookieContext": "이 웹사이트는 쿠키를 사용하여 웹사이트를 원활하게 운영하고 상호 작용하는 방법을 이해하는 데 도움을 줍니다. 이러한 쿠키를 사용하여 더 나은 맞춤형 사용자 경험을 제공합니다. 이 웹사이트를 계속 사용하면 쿠키 사용에 동의하는 것으로 간주됩니다.",
  "order_reivice_message": "배송물품을 받으셨나요?",
  "order_reivice_btn": "수령확인",
  "order_reivice_label": "주문수령",
  "order_reivice_success": "받는 것을 확인하였습니다.",
  "collpase_show": "더보기",
  "collpase_hide": "접기",
  "CouponCode": "할인코드",
  "wechatPayScannerCode": "위챗으로 QR코드 결제를 이용해주세요.",
  "processing": "판매 후 처리 중",
  "finished": "판매 후 완료",
  "login.showPrice": "로그인 후 가격查看",
  "After_Sales_Unknown": "판매 후 상태 불명",
  "order_payment_list_null": "대기 중인 주문이 없습니다",
  "Cancel": "취소",
  "thankyou_concat": "문의 사항이 있으시면 저희에게 연락해 주시기 바랍니다"
}